import PropTypes from 'prop-types';

import {monetaryConstants} from '../Monetary';


// ------ actions
export const ACTION_CART_LOADED = 'ACTION_CART_LOADED';

export const ACTION_CARTS_LOADING = 'ACTION_CARTS_LOADING';

export const ACTION_CARTS_LOADED = 'ACTION_CARTS_LOADED';

export const ACTION_CART_HEADER_UPDATED = 'ACTION_CART_HEADER_UPDATED';

export const ACTION_CART_ITEMS_REMOVED = 'ACTION_CART_ITEMS_REMOVED';

export const ACTION_CART_SUBMITTED = 'ACTION_CART_SUBMITTED';


// ------ item
export const CART_ITEM_CONTENT_STATUS_INVALID = 'invalid';
export const CART_ITEM_CONTENT_STATUS_VALID = 'valid';

export const CART_ITEM_CONTENT_STATUSES = [
    CART_ITEM_CONTENT_STATUS_INVALID,
    CART_ITEM_CONTENT_STATUS_VALID
];


export const CART_ITEM_TYPE_CONTENT = 'content';

export const CART_ITEM_TYPES = [
    CART_ITEM_TYPE_CONTENT
];


// ----- cart add to cart content checks
export const CART_ADD_TO_CART_CHECK_REASON_DIFFERENT_PUBLICATION = 'different-publication';

export const CART_ADD_TO_CART_CHECK_REASON_STATUS_NOT_ORDERABLE = 'status-not-orderable';



// ------ nav
const NAV_BASE = '/cart';

export const NAV_PAGE_CART = `${NAV_BASE}/:cartId`;

export const NAV_PAGE_CHECKOUT = `${NAV_BASE}/:cartId/checkout`;



// ------ validity (in milliseconds)
export const CART_VALIDITY_MINUTES = 30;
export const CART_VALIDITY_SECONDS = CART_VALIDITY_MINUTES * 60;
export const CART_VALIDITY_MILLIS = CART_VALIDITY_SECONDS * 1000;



// ------ shape
export const SHAPE_ADD_TO_CART_ITEM_CONTENT = {
    contentId: PropTypes.string.isRequired,
    itemType: PropTypes.oneOf(CART_ITEM_TYPES).isRequired
};


export const SHAPES_ADD_TO_CART_ITEMS = PropTypes.arrayOf(
    PropTypes.oneOfType([
        PropTypes.shape(SHAPE_ADD_TO_CART_ITEM_CONTENT)
    ])
).isRequired;



export const SHAPE_DISCOUNT = {
    type: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
};


const SHAPE_CART_ITEM_BASE = {
    description: PropTypes.string.isRequired,
    discount: PropTypes.number.isRequired,
    discounts: PropTypes.arrayOf(PropTypes.shape(SHAPE_DISCOUNT)).isRequired,
    grossPrice: PropTypes.number.isRequired,
    isValid: PropTypes.bool.isRequired,
    itemType: PropTypes.oneOf(CART_ITEM_TYPES).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired,
    tax: PropTypes.number.isRequired,
    taxRate: PropTypes.number.isRequired,
    unitPrice: PropTypes.number.isRequired,
    unitQuantityPrice: PropTypes.number.isRequired
};

export const SHAPE_CART_ITEM_CONTENT = {
    ...SHAPE_CART_ITEM_BASE,
    contentId: PropTypes.string,
    contentItemStatus: PropTypes.oneOf(CART_ITEM_CONTENT_STATUSES).isRequired
};

export const SHAPE_CART_ITEMS = PropTypes.arrayOf(
    PropTypes.oneOfType([
        PropTypes.shape(SHAPE_CART_ITEM_CONTENT)
    ])
);



export const SHAPE_CART_HEADER = {
    currency: PropTypes.shape(monetaryConstants.SHAPE_CURRENCY).isRequired,
    id: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    totalDiscount: PropTypes.number.isRequired,
    totalGrossPrice: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
    totalPrice: PropTypes.number.isRequired,
    totalQuantity: PropTypes.number.isRequired,
    totalTax: PropTypes.number.isRequired
};


export const SHAPE_CART_DETAILS = {
    ...SHAPE_CART_HEADER,
    customerPoNumber: PropTypes.string,
    discounts: PropTypes.arrayOf(PropTypes.shape(SHAPE_DISCOUNT)).isRequired,
    isValid: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape(SHAPE_CART_ITEM_CONTENT)).isRequired
};
